// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 977 ? "orderCreate" : chunkId) + "." + {"381":"1ecf3cab","977":"974bd137"}[chunkId] + ".css";
};